import { logError } from '@/shared/logger'

const icons: Map<string, Promise<any>> = new Map()

async function getAsset(iconName: string): Promise<any> {
  const icon = icons.get(iconName)
  if (icon) {
    return icon
  }
  const promise = import('@/assets/skeletons/' + iconName + '.vue')
    .then((module: any) => {
      return module.default ?? module
    })
    .catch((error: any) => {
      logError('Unable to load icon', iconName, error)
    })
  icons.set(iconName, promise)
  return promise
}

export function useAssetCache() {
  return {
    getAsset,
  }
}
